import { createSlice } from "@reduxjs/toolkit";
import { createChangeRequest, generatePresignedURL, getAllChangeRequests, getAllLocs, getAllReportees } from "./thunk";

const initialState = {

  createChangeRequestResponse: null,
  createChangeRequestResponseStatus: null,

  getAllChangeRequestsResponse: null,
  getAllChangeRequestsResponseStatus: null,

  getAllReporteesResponse: null,
  getAllReporteesResponseStatus: null,

  generatePresignedURLResponse: null,
  generatePresignedURLResponseStatus: null,

  getAllLocsResponse: null,
  getAllLocsResponseStatus: null,

  loading: false,

};

const requestSlice = createSlice({
  name: "request",
  initialState: initialState,
  reducers: {

    setLoading: (state, action) => {
      state.loading = action.payload;
    },

    setInitialState: (state) => {
      return initialState
    }


  },
  extraReducers: (builder) => {

    builder.addCase(createChangeRequest.pending, (state, action) => {
      state.createChangeRequestResponse = null;
      state.createChangeRequestResponseStatus = "PENDING";
    });
    builder.addCase(createChangeRequest.rejected, (state, action) => {
      state.createChangeRequestResponse = action.payload;
      state.createChangeRequestResponseStatus = "ERROR";
    });
    builder.addCase(createChangeRequest.fulfilled, (state, action) => {
      state.getAllReporteesResponse = null
      state.getAllReporteesResponseStatus = null

      state.createChangeRequestResponse = action.payload;
      state.createChangeRequestResponseStatus = "SUCCESS";

    });

    builder.addCase(getAllChangeRequests.pending, (state, action) => {
      state.getAllChangeRequestsResponse = null;
      state.getAllChangeRequestsResponseStatus = "PENDING";
    });
    builder.addCase(getAllChangeRequests.rejected, (state, action) => {
      state.getAllChangeRequestsResponse = action.payload;
      state.getAllChangeRequestsResponseStatus = "ERROR";
    });
    builder.addCase(getAllChangeRequests.fulfilled, (state, action) => {
      state.getAllChangeRequestsResponse = action.payload;
      state.getAllChangeRequestsResponseStatus = "SUCCESS";
    });

    builder.addCase(getAllReportees.pending, (state, action) => {
      state.getAllReporteesResponse = null;
      state.getAllReporteesResponseStatus = "PENDING";
    });
    builder.addCase(getAllReportees.rejected, (state, action) => {
      state.getAllReporteesResponse = action.payload;
      state.getAllReporteesResponseStatus = "ERROR";
    });
    builder.addCase(getAllReportees.fulfilled, (state, action) => {
      state.getAllReporteesResponse = action.payload;
      state.getAllReporteesResponseStatus = "SUCCESS";
    });

    builder.addCase(generatePresignedURL.pending, (state, action) => {
      state.generatePresignedURLResponse = null;
      state.generatePresignedURLResponseStatus = "PENDING";
    });
    builder.addCase(generatePresignedURL.rejected, (state, action) => {
      state.generatePresignedURLResponse = action.payload;
      state.generatePresignedURLResponseStatus = "ERROR";
    });
    builder.addCase(generatePresignedURL.fulfilled, (state, action) => {
      state.generatePresignedURLResponse = action.payload;
      state.generatePresignedURLResponseStatus = "SUCCESS";
    });

    builder.addCase(getAllLocs.pending, (state, action) => {
      state.getAllLocsResponse = null;
      state.getAllLocsResponseStatus = "PENDING";
    });
    builder.addCase(getAllLocs.rejected, (state, action) => {
      state.getAllLocsResponse = action.payload;
      state.getAllLocsResponseStatus = "ERROR";
    });
    builder.addCase(getAllLocs.fulfilled, (state, action) => {
      state.getAllLocsResponse = action.payload;
      state.getAllLocsResponseStatus = "SUCCESS";
    });
  },
});

export const requestActions = requestSlice.actions;

export default requestSlice.reducer;
